module.exports = __webpack_public_path__ + "img/ShengshuTechnology.a1e66ba3.jpg";